const ButtonLinkVariants = {
  primary: 'primary',
  secondary: 'secondary',
};

export default ButtonLinkVariants;
